<template>
    <div class="assetHandover-manage">
        <Paper class="assetHandover-manage-paper">
            <el-tabs class="assetHandover-list-tab-pane" v-model="activeTabs" @tab-click="tabClick" @tab-remove="removeTab">
                <el-tab-pane label="人员异动资产交接" name="theList" ref="myPane">
                    <list-layout-paper>
                        <template slot="header-search" class="searchBox">
                            <search-box
                                ref="searchBox"
                                :search-key="config.name"
                                :fields="config.searchFields"
                                :showResetBtn="true"
                                @search-change="tableList.searchList"
                                @elementChange="elementChange"
                            />
                        </template>
                        <template slot="header-button">
                            <!--
                                点击新建流程，
                                新建时需校验，同一个交接人，仅支持在同一时间存在一个流程，
                                当上一个流程完成时，才支持为该交接人建下一个流程，
                                如：用户A有交接流程在草稿中、审批中，不能给A新建流程，知道A的该流程通过或被删除，才允许新建新的流程
                            -->
                            <lotsButton type="primary" icon="el-icon-plus" size="mini" title="新增" @click="createOpera">
                                新增
                            </lotsButton>
                            <lotsButton
                                type="primary"
                                size="mini"
                                title="刷新"
                                @click="refresh"
                                plain>
                                <span class="icon iconfont icon-refresh"></span>
                            </lotsButton>
                            <el-tooltip effect="dark" :content="'列配置'" placement="bottom">
                                <el-button
                                    icon="iconfont icon-list_install"
                                    type="primary"
                                    size="mini"
                                    :title="'列配置'"
                                    @click="showColumnConfigDialog"
                                    plain />
                            </el-tooltip>
                        </template>
                        <!-- 表格 -->
                        <template v-slot:list="{ tableHeight }">
                            <edit-table-box
                                ref="editTableBox"
                                key="assetHandover"
                                v-loading="tableList.tableLoading"
                                :index="config.index"
                                :selection="config.selection"
                                :columns="config.columns"
                                :height="tableHeight"
                                :tableData="tableList.totalData"
                                :actions="config.actions"
                                :control="true"
                                :allowRowClick="false"
                                @btn-event="handleActive"
                            >
                                <template v-slot:col-append="{ item, row }">
                                    <span v-if="['status'].includes(item.prop)">
                                        {{ formatDictCodeToName(row[item.prop], dictDatas[item.optionsKey]) }}
                                    </span>
                                </template>
                            </edit-table-box>
                        </template>
                        <template slot="footer">
                            <lots-pagination
                                :page-size.sync="tableList.pageSize"
                                @size-change="tableList.sizeChange"
                                :current-page.sync="tableList.pageNo"
                                @current-change="tableList.pageChange"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="tableList.pageTotal" >
                            </lots-pagination>
                        </template>
                    </list-layout-paper>
                </el-tab-pane>

                <!-- 详情页签 -->
                <el-tab-pane
                    class="detail-pane"
                    closable
                    v-for="item in tabList"
                    :key="item.tagName"
                    :label="item.tagName"
                    :name="String(item.tagName)"
                >
                    <setting
                        :ref="'settingRef' + item.tagName"
                        :data="item" :dictDatas="dictDatas"
                        :handoverPersonOptions="handoverPersonOptions"
                        @createSuccessHandle="createFinish"
                        @close="closeHandle"
                    />
                </el-tab-pane>
            </el-tabs>
        </Paper>

        <!-- 表格列配置弹框 -->
        <column-config
            :pageID="config.name"
            :initColumns="config.columns"
            ref="otpColumnConfig"
            @header-change="config.columns = $event"
        />
    </div>
</template>

<script>
import { ref, reactive, onMounted, getCurrentInstance } from '@vue/composition-api';
import store from '@/store';
import { Message, MessageBox } from 'element-ui';
import searchBox from '@/components/lots/searchBox';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import lotsButton from '@/components/lots/lotsButton';
import editTableBox from '@/components/lots/editTableBox/Index';
import { getList, getSubUserList, getManageOrgList, deleteApi } from '@/modules/mdm/api/customer/assetHandover/index.js';
import { config as configStatic } from './config';
import setting from './setting.vue';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import columnConfig from '@/components/lots/columnConfig/Index';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import { formatDictCodeToName } from '@/modules/mdm/utils.js';
import utils from '@/components/utils/common.js';

export default {
    name: 'assetHandover',
    components: {
        Paper,
        searchBox,
        listLayoutPaper,
        lotsButton,
        editTableBox,
        lotsPagination,
        setting,
        columnConfig
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        // 获取Vue实例
        const instance = getCurrentInstance();
        const router = instance ? instance.$router : null;
        const route = instance ? instance.$route : null;

        // 按钮权限
        const authorityCode = reactive(btnAuthority.submissionApplication);
        const config = reactive(configStatic);
        const otpColumnConfig = ref(null);
        // 列表列配置弹窗-打开
        const showColumnConfigDialog = () => {
            otpColumnConfig.value.show(true);
        };

        const activeTabs = ref('theList');
        // 打开的详情tab页集
        const tabList = ref([]);
        // 删除详情标签
        const removeTab = (tagName) => {
            if (activeTabs.value === tagName) {
                activeTabs.value = 'theList';
                // 清除URL参数
                if (router) {
                    router.push({ query: {} }).catch(() => {});
                }
            }
            tabList.value = tabList.value.filter(
                (tab) => String(tab.tagName) !== tagName
            );
        };

        const tabClick = (tabObj) => {
            const currentTab = tabList.value.find(v => v.tagName === tabObj.label);
            if (currentTab) {
                // 更新URL参数
                if (router && currentTab.operationType) {
                    const params = {};
                    if (currentTab.operationType) {
                        params.mode = currentTab.operationType;
                    }
                    if (currentTab.transferNo) {
                        params.transferNo = currentTab.transferNo;
                    }
                    router.push({ query: params }).catch(() => {});
                } else {
                    router.push({ query: {} }).catch(() => {});
                }

                doLayoutFunc(tabObj.label);
            } else {
                setupContext.root.$nextTick(() => {
                    const editTableBoxRef = setupContext.refs.editTableBox;
                    if (editTableBoxRef?.$refs?.moduleTable) {
                        editTableBoxRef.$refs.moduleTable.doLayout(); // 解决表格错位
                    }
                });
                router.push({ query: {} }).catch(() => {});
            }
        };

        // 处理tab切换的时候，table的宽度明显抖动问题！！！！！！！
        const doLayoutFunc = (name) => {
            setupContext.root.$nextTick(function() {
                // 定义需要调用doLayout的组件名称数组
                const componentNames = ['clue', 'customer', 'customerGroup', 'warehouse', 'fullBusiness', 'biddingOppo', 'contact', 'contract', 'allocationDetails'];

                // 获取当前标签页的settingRef组件
                const settingRef = setupContext.refs['settingRef' + name] && setupContext.refs['settingRef' + name][0];

                if (settingRef) {
                    // 循环调用每个组件的doLayout方法，并添加错误处理
                    componentNames.forEach(function(componentName) {
                        try {
                            var component = settingRef.$refs[componentName];
                            if (component && component.$refs.editTableBox && component.$refs.editTableBox.$refs.moduleTable) {
                                component.$refs.editTableBox.$refs.moduleTable.doLayout();
                            }
                        } catch (error) {
                            console.warn('Failed to doLayout for ' + componentName + ':', error);
                        }
                    });
                }
            });
        };

        /**
         * @description: 开详情页通用部分代码
         * @param {Object} data 页面数据对象
         * @param {String} name 页面名称信息
         *  */
        // eslint-disable-next-line complexity
        const newDetailPage = (name, data) => {
            const params = {
                tagName: name,
                ...data
            };
            // 3. 查找是否已存在的标签页
            const existingTab = tabList.value.find(v => v.tagName === name);
            if (!existingTab) {
                if (tabList.value.length >= 8) {
                    return Message.warning('已超出8个详情页，请关闭后重新打开');
                } else {
                    tabList.value.push(params);
                    activeTabs.value = String(params.tagName);
                }
            } else {
                // 4. 如果已存在，直接切换
                activeTabs.value = String(existingTab.tagName);
            }

            // 更新URL参数
            if (router && data.operationType) {
                const params = {
                    mode: data.operationType
                };
                if (data.transferNo) {
                    params.transferNo = data.transferNo;
                }
                router.push({ query: params }).catch(() => {});
            } else {
                router.push({ query: {} }).catch(() => {});
            }
        };

        const createOpera = () => {
            // 新建时需校验，同一个交接人，仅支持在同一时间存在一个流程，
            // 当上一个流程完成时，才支持为该交接人建下一个流程，
            // 如：用户A有交接流程在草稿中、审批中，不能给A新建流程，知道A的该流程通过或被删除，才允许新建新的流程
            newDetailPage('新建交接流程', { operationType: 'add' });
        };

        const toDetailPage = (row) => {
            const type = row.operationType === 'edit' ? '编辑' : '查看';
            const name = type + row.transferNo + '流程';
            newDetailPage(name, row);
        };

        // 新增/编辑完成后刷新列表
        const createFinish = (data) => {
            // removeTab(String(data.id));
            tableList.getList();
        };

        // 关闭tab页面
        const closeHandle = () => {
            removeTab(activeTabs.value);
        };

        const searchDataFormat = (condition) => {
            if (condition.userCode) {
                if (userType.value === 'initiatorCode') {
                    condition.initiatorCode = condition.userCode;
                }
                if (userType.value === 'transferUserCode') {
                    condition.transferUserCode = condition.userCode;
                }
            }
            if (condition.createTime) {
                condition.startTime = utils.formatDateTime(condition.createTime[0]);
                condition.endTime = utils.formatDateTime(condition.createTime[1]);
            }
            // 批量删除属性
            const propertiesToDelete = [
                'userCode',
                'userName',
                'selectList',
                'createTime'
            ];
            propertiesToDelete.forEach(prop => delete condition[prop]);

            // 优化属性遍历
            Object.keys(condition).forEach(key => {
                if (condition[key] === '' || condition[key] === null || condition[key] === undefined || condition[key].length === 0) {
                    delete condition[key];
                }
            });
            return condition;
        };

        const userType = ref('');
        const elementChange = (data) => {
            // 发起人
            if (data.column.value === 'initiatorCode') {
                userType.value = 'initiatorCode';
            }
            // 交接人
            if (data.column.value === 'transferUserCode') {
                userType.value = 'transferUserCode';
            }
        };

        class ListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };

            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map(v => {
                        return {
                            ...v
                        };
                    });
                    this.pageTotal.value = res.data.totalCount;
                }
                setupContext.root.$nextTick(() => {
                    const editTableBoxRef = setupContext.refs.editTableBox;
                    if (editTableBoxRef?.$refs?.moduleTable) {
                        editTableBoxRef.$refs.moduleTable.doLayout(); // 解决表格错位
                    }
                });
            };
        }

        const tableList = new ListClass({
            Api: {
                listApi: getList // 查询接口
            },
            pageSize: 20
        });

        // 操作项
        const handleActive = (row, event) => {
            // 编辑
            if (event === 'editOpera') {
                row.operationType = 'edit';
                toDetailPage(row);
            }
            // 查看
            if (event === 'lookOpera') {
                row.operationType = 'view';
                toDetailPage(row);
            }
            // 删除
            if (event === 'deleteOpera') {
                deleteOpera(row);
            }
        };

        // 删除
        const deleteOpera = (row) => {
            MessageBox.confirm('将删除该草稿，请确认。', '温馨提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                tableList.tableLoading.value = true;
                const params = {
                    ids: [row.id]
                };
                deleteApi(params).then(res => {
                    if (+res.code === 0) {
                        Message.success('删除成功');
                        tableList.getList();
                    }
                }).finally(() => {
                    tableList.tableLoading.value = false;
                });
            }).catch(() => {
                // 用户点击取消按钮，不做任何处理，避免 unhandledrejection: cancel 警告
            });
        };

        // 刷新列表
        const refresh = () => {
            tableList.getList();
        };

        // 获取交接人列表
        // 选择交接人：权限范围内，个人用户可选择自己，管理层可选择自己权限范围内：本部门个人用户，上级经理为本人的用户（个人和管理层），下级部门的所有人。
        // 选择交接人
        const handoverPersonOptions = ref([]);
        const getSubUserApi = () => {
            return new Promise((resolve, reject) => {
                getSubUserList({ superiorCode: store.state.user.user.userCode }).then(res => {
                    if (+res.code === 0) {
                        handoverPersonOptions.value = res.data || [];
                        resolve(res.data);
                    }
                }).finally(() => {

                });
            });
        };

        const dictDatas = ref({});
        onMounted(async() => {
            dictDatas.value = await otherUtils.getDictDataList(config.columns);
            getManageOrgList({}).then(res => {
                if (+res.code === 0) {
                    const manageOrgList = res.data.map(v => ({
                        label: v.fullName,
                        value: v.orgCode
                    }));
                    const deptField = configStatic.searchFields.find(item => item.value === 'transferDeptCodeList');
                    if (deptField) {
                        deptField.options = manageOrgList;
                    }
                    config.searchFields = configStatic.searchFields;
                }
            });
            tableList.getList();
            // 获取交接人列表
            getSubUserApi().then(userlist => {
                // 检查URL参数，如果存在id则自动打开对应的详情页
                if (route && route.query.mode) {
                    const mode = route.query.mode;
                    const transferNo = route.query.transferNo;
                    if (mode === 'add') {
                        createOpera();
                    }
                    if ((mode === 'view' || mode === 'edit') && transferNo) {
                        // 校验type参数是否有效，有效则使用，无效则默认使用'l'
                        const operationType = (mode === 'edit' || mode === 'view') ? mode : 'view';
                        const params = {
                            transferNo,
                            operationType
                        };
                        toDetailPage(params);
                    }
                }
            });
        });

        return {
            tableList,
            config,
            handleActive,
            activeTabs,
            tabList,
            removeTab,
            tabClick,
            createOpera,
            createFinish,
            closeHandle,
            authorityCode,
            showColumnConfigDialog,
            otpColumnConfig,
            refresh,
            toDetailPage,
            dictDatas,
            handoverPersonOptions,
            formatDictCodeToName,
            elementChange
        };
    }
};
</script>

<style lang="less">
.list-dropdown.el-dropdown {
    color: #fff;
}

.assetHandover-list-dropdown-menu {
    background-color: #fff;
    .el-dropdown-menu__item.dropdown-item {
        width: auto;
    }
}

.assetHandover-manage {
    width: 100%;

    .assetHandover-manage-paper {
        height: 100%;
    }

    .list-layout-wrapper {
        height: 100%;
    }

    .assetHandover-list-tab-pane.el-tabs {
        width: 100%;
        height: 100%;

        &>.el-tabs__content {
            height: calc(100% - 40px - 14px);
            overflow: auto;

            &>.el-tab-pane {
                overflow: auto;
                padding-right: 5px;
                height: 100%;

                .list-main {
                    .table-box {
                        height: 100%;
                    }
                }
            }
        }
    }

    .flex-layout .list-main {
        overflow: auto;
    }

    .list-layout .list-header .el-input {
        margin-left: 0;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .list-header {
        .assetHandover-manage-list-dropdown.el-dropdown {
            color: #fff;
        }
    }

    .layout-content.assetHandover-manage-paper {
        padding: 0px 20px 20px;

        .el-table .cell.el-tooltip {
            &>div {
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .list-layout-wrapper {
        padding: 0px;
    }
}

.assetHandover-manage-list-dropdown-menu {
    background-color: #fff;
}

.column-config_title {
    font-size: 14px;
}
</style>
